import { User, Group, UserGroup } from '../services/permissionService';

export function formatUserDisplayName(user: User): string {
  return `${user.first_name} ${user.last_name} (${user.email})`;
}

export function sortUserGroupsByUserName(userGroups: UserGroup[]): UserGroup[] {
  return [...userGroups].sort((a, b) => {
    const nameA = `${a.user.first_name} ${a.user.last_name}`.toLowerCase();
    const nameB = `${b.user.first_name} ${b.user.last_name}`.toLowerCase();
    return nameA.localeCompare(nameB);
  });
}

export function findUserCurrentGroups(userGroups: UserGroup[], userId: number): Group[] {
  return userGroups
    .filter(userGroup => userGroup.user_id === userId)
    .map(userGroup => userGroup.group);
}

export function getUserGroupsFromUserData(user: User): Group[] {
  return user.groups || [];
}

export function hasAdminPrivileges(user: User): boolean {
  return user.groups.some(group => 
    group.name === 'super-admin' || group.name === 'work-area-admin'
  );
}

export function getUserRole(user: User): string {
  if (user.groups.some(group => group.name === 'super-admin')) {
    return 'Super Admin';
  }
  if (user.groups.some(group => group.name === 'work-area-admin')) {
    return 'Work Area Admin';
  }
  return 'User';
}

export function convertUsersToUserGroups(users: User[]): UserGroup[] {
  const userGroups: UserGroup[] = [];
  
  users.forEach(user => {
    user.groups.forEach(group => {
      userGroups.push({
        user_id: user.id,
        group_id: group.id,
        user: user,
        group: group
      });
    });
  });
  
  return userGroups;
}

export function findUserAvailableGroups(currentGroups: Group[], allGroups: Group[]): Group[] {
  const currentGroupIds = currentGroups.map(group => group.id);
  return allGroups.filter(group => !currentGroupIds.includes(group.id));
} 
